/**
 * Media type selector component
 */

import React from 'react';
import { Label } from '@/ui-components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui-components/ui/select';
import { getMediaTypeIcon, getMediaTypeDisplayName } from './utils';
import { MediaType } from '@/page-components/post-generator/core/template.schemas';

interface MediaTypeSelectorProps {
  /** Selected media type */
  selectedMediaType: MediaType;
  /** Available media types */
  compatibleMediaTypes: MediaType[];
  /** Change handler */
  onMediaTypeChange: (mediaType: MediaType) => void;
}

/**
 * Selector for choosing media type when multiple types are compatible
 */
export const MediaTypeSelector: React.FC<MediaTypeSelectorProps> = ({
  selectedMediaType,
  compatibleMediaTypes,
  onMediaTypeChange
}) => {
  // Don't render if only one media type is available
  if (compatibleMediaTypes.length <= 1) {
    return null;
  }

  return (
    <div>
      <Label className="text-xs text-gray-500 mb-1 block">Typ</Label>
      <Select 
        value={selectedMediaType} 
        onValueChange={(value) => onMediaTypeChange(value as MediaType)}
      >
        <SelectTrigger className="h-6 text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {compatibleMediaTypes.map((mediaType) => (
            <SelectItem key={mediaType} value={mediaType} className="text-xs">
              <div className="flex items-center gap-2">
                {getMediaTypeIcon(mediaType)}
                {getMediaTypeDisplayName(mediaType)}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};